import { Box, Stack } from '@chakra-ui/react';
import { antlerStyle } from '@constants/styles';

const JuiceBox = ({ children, ...rest }) => {
  return (
    <>
      <Box
        backgroundImage={"url('/boxes.png')"}
        backgroundSize={900}
        mt={0}
        mx="auto"
        pt={[10, 10, 8, '60px']}
        pb={[4, 4, 8, '100px']}
        px={['18px', '24px', '24px', '80px']}
        minH={antlerStyle.heroHeight}
        {...rest}
      >
        <Stack w="100%" alignItems="center" spacing={0}>
          {children}
        </Stack>
      </Box>
    </>
  );
};

export default JuiceBox;
